import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { Texture } from '@pixi/core';
var FillStyle = /*#__PURE__*/function () {
  function FillStyle() {
    _classCallCheck(this, FillStyle);
    this.color = 16777215;
    this.alpha = 1;
    this.texture = Texture.WHITE;
    this.matrix = null;
    this.visible = false;
    this.reset();
  }
  _createClass(FillStyle, [{
    key: "clone",
    value: function clone() {
      var obj = new FillStyle();
      obj.color = this.color;
      obj.alpha = this.alpha;
      obj.texture = this.texture;
      obj.matrix = this.matrix;
      obj.visible = this.visible;
      return obj;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.color = 16777215;
      this.alpha = 1;
      this.texture = Texture.WHITE;
      this.matrix = null;
      this.visible = false;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.texture = null;
      this.matrix = null;
    }
  }]);
  return FillStyle;
}();
export { FillStyle };